/**
 * Column options specific to all column types.
 */
export interface ColumnEmbeddedOptions {

    /**
     * Embedded column prefix.
     */
    prefix?: string;

}
